import {isJsonString} from './isJsonString';

export default function recursiveParse(input) {
  //console.log("recursiveParse input:", input);
  if (typeof input === 'string' && isJsonString(input)) {
    //console.log("recursiveParse detected JSON string");
    try {
      //console.log("recursiveParse attempting to parse JSON string");
      const parsed = JSON.parse(input);
      return recursiveParse(parsed);
    } catch (e) {
      console.error("recursiveParse failed to parse JSON string:", e);
      return input;
    }
  } else if (Array.isArray(input)) {
    //console.log("recursiveParse detected array");
    return input.map(item => recursiveParse(item));
  } else if (input !== null && typeof input === 'object') {
    //console.log("recursiveParse detected object");
    const parsedObject = {};
    for (const key in input) {
      //console.log("recursiveParse processing key:", key);
      if (input.hasOwnProperty(key)) {
        //console.log("recursiveParse has own property for key:", key);
        parsedObject[key] = recursiveParse(input[key]);
      }
    }
    //console.log("recursiveParse finished processing object");
    return parsedObject;
  }
  //console.log("recursiveParse reached non-object, non-array, non-JSON string input");
  return input;
}